/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type FavoriteItemAction = "ADD" | "REMOVE" | "%future added value";
export type FavoriteItemInput = {
    readonly action: FavoriteItemAction;
    readonly userId: string;
    readonly itemId: string;
    readonly portfolioId?: string | null;
    readonly clientMutationId?: string | null;
};
export type TagProjectMutationVariables = {
    readonly input: FavoriteItemInput;
    readonly userId: string;
};
export type TagProjectMutationResponse = {
    readonly favoriteItem: {
        readonly item: {
            readonly isFavorite: boolean | null;
            readonly serviceId: string | null;
            readonly projects: ReadonlyArray<{
                readonly serviceId: string | null;
                readonly name: string | null;
                readonly portfolio: {
                    readonly serviceId: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
};
export type TagProjectMutation = {
    readonly response: TagProjectMutationResponse;
    readonly variables: TagProjectMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "FavoriteItemInput!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ], v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isFavorite",
        "args": (v2 /*: any*/),
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "TagProjectMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "favoriteItem",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "FavoriteItemPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "projects",
                                    "storageKey": null,
                                    "args": (v2 /*: any*/),
                                    "concreteType": "Project",
                                    "plural": true,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "portfolio",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfolioV2",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "TagProjectMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "favoriteItem",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "FavoriteItemPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "projects",
                                    "storageKey": null,
                                    "args": (v2 /*: any*/),
                                    "concreteType": "Project",
                                    "plural": true,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "portfolio",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfolioV2",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v6 /*: any*/)
                                            ]
                                        },
                                        (v6 /*: any*/)
                                    ]
                                },
                                (v6 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "TagProjectMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/TagProjectMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '2000719dc0ae6bf7a090e1e1d97bee57';
export default node;
